import styled from 'styled-components';

import { Typography } from '../typography';

interface IPropsTab {
	isActive: boolean;
	totalTabs: number;
}

const Tab = styled.button<IPropsTab>`
	background-color: ${p => p.theme.colors.bgrdGrey};
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 60px;
	margin: 0 85px 0 10px;
`;

const Descr = styled(Typography)`
	font-size: 22px;
	line-height: 26px;
	text-align: center;
`;

const Counter = styled.div`
	background-color: ${p => p.theme.colors.scrollbarColor};
	border-radius: 50%;
	width: 24px;
	height: 24px;
	margin-left: 10px;

	span {
		color: #7a7f8d;
	}
`;

const Mark = styled.div`
	background-color: ${p => p.theme.colors.sapphirine};
	z-index: 999;
	position: absolute;
	bottom: -1px;
	width: 100%;
	height: 4px;
	//border-top-left-radius: 20px;
	//border-top-right-radius: 20px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	Tab,
	Descr,
	Counter,
	Mark,
};
